import {
     ADD_GOALS_ACHIEVED_SUCCESS,
     GET_APPRAISAL_QUESTIONS_SUCCESS, 
     GET_APPRAISEE_DETAILS_SUCCESS,  
     GET_APPRAISEE_PERFORMANCEGOALS_SUCCESS, 
     GET_ATTRIBUTE_LIST_SUCCESS, 
     GET_BEHAVIOUR_ATTRIBUTES_SUCCESS, 
     GET_EXPERTLEVEL_SUCCESS, 
     GET_GOALS_ACHIEVED_SUCCESS, 
     GET_GOALS_BY_DESIGNATION_SUCCESS, 
     GET_POTENTIAL_LIST_SUCCESS, 
     GET_RATING_LIST_SUCCESS, 
     GET_TECHNICAL_CAPABILITY_SUCCESS, 
     SAVEAPPRAISEEDETAILS_SELFREVIEW_SUCCESS,
     SAVE_BEHAVIOUR_ATTRIBUTES_SUCCESS,
     SAVE_PERFORMANCEGOALS_SUCCESS,
     SAVE_PERFORMANCE_LEARNING_PLAN_SUCCESS,
     SAVE_TECHNICAL_CAPABILITY_SUCCESS,
     GET_PERFORMANCE_LEARNING_PLAN_SUCCESS,
     SUBMITDATA_SUCCESS,
     GET_REVIEW_APPRAISEE_LIST_SUCCESS,
     GET_APPRAISAL_ENABLE_ADMIN_LIST_SUCCESS,
     ENABLE_ALL_APPRAISEE_SUCCESS,
     CHECK_APPRAISAL_ENABLED_STATE_SUCCESS,
     ADD_APPRAISAL_QUESTIONS_SUCESS,
     UPDATE_APPRAISAL_QUESTIONS_SUCESS,
     DELETE_APPRAISAL_QUESTIONS_SUCESS,
     DELETE_TECHNICAL_CAPABILITY_SUCCESS,
     DELETE_GOALS_ACHIEVED_SUCCESS,
     DELETE_PERFOMANCE_GOALS_SUCCESS,
     GET_PERFOMANCE_GOALS_SUCCESS,
     DELETE_APPRAISAL_QUESTIONS_ERROR
  } from "../../actions/actionType";
  
  const initialState = {
    appraisalQuestionList: [],
    AppraiseeDetails:{},
    expertLevel:[],
    goalsAchieved:[],
    goals:[],
    ratings:[],
    performanceGoals:[],
    potentialList:[],
    technicalCapability:[],
    attributes:[],
    behavioural_attributes:[],
    performancelearningplan:null,
    submitDataStatus:[],
    reviewAppraiseeList:[],
    appraisalEnableList:[],
    appraisalQuestionList :[],
    appraisalEnableStatus : false,
    appraisalQuestionError:true,
  };

  export default function (state = initialState, action) {
    switch (action.type) {
      case GET_APPRAISAL_QUESTIONS_SUCCESS:
        return {
          ...state,
          appraisalQuestionList: action.payload,
        };
        case ADD_APPRAISAL_QUESTIONS_SUCESS:
          return {
            ...state,
            appraisalQuestionList: [...state.appraisalQuestionList, action.payload],
          };
      
          case UPDATE_APPRAISAL_QUESTIONS_SUCESS:

          return {
            ...state,
            appraisalQuestionList: state.appraisalQuestionList.map((el) =>
              el.appraisalQuestionId === action.payload.appraisalQuestionId ? action.payload : el
            ),
          };
        case DELETE_APPRAISAL_QUESTIONS_SUCESS:
          return {
  
            ...state,
            appraisalQuestionList: state.appraisalQuestionList.filter(
              (el) => el.appraisalQuestionId !== action.payload
            ),
          };

          case DELETE_APPRAISAL_QUESTIONS_ERROR:
            return {
              ...state,
              appraisalQuestionError: false,
            };
      case SAVEAPPRAISEEDETAILS_SELFREVIEW_SUCCESS:
        return {
          ...state,
          AppraiseeDetails: [...state.AppraiseeDetails, action.payload],
        };
      case GET_APPRAISEE_DETAILS_SUCCESS:
        return {
            ...state,
            AppraiseeDetails: action.payload,
        }
      case GET_EXPERTLEVEL_SUCCESS:
        return {
            ...state,
            expertLevel: action.payload,
        }
      case ADD_GOALS_ACHIEVED_SUCCESS:
        return {
            ...state,
            goalsAchieved: action.payload,
        }
      case GET_GOALS_ACHIEVED_SUCCESS:
        return {
            ...state,
            goalsAchieved: action.payload,
        }
        case DELETE_GOALS_ACHIEVED_SUCCESS:
        return {
            ...state,
            goalsAchieved: action.payload,
        }
      // case GET_GOALS_BY_DESIGNATION_SUCCESS:
      //   return {
      //       ...state,
      //       goals: action.payload,
      //   }
      case GET_RATING_LIST_SUCCESS:
        return {
            ...state,
            ratings: action.payload,
        }
        case GET_GOALS_BY_DESIGNATION_SUCCESS:
          return {
              ...state,
              goals: action.payload,

          };
      case SAVE_PERFORMANCEGOALS_SUCCESS:
        return {
            ...state,
            performanceGoals:  action.payload,
        }
      case GET_APPRAISEE_PERFORMANCEGOALS_SUCCESS:
        return {
            ...state,
            performanceGoals: action.payload,
        }
        case DELETE_PERFOMANCE_GOALS_SUCCESS:
        return {
            ...state,
            performanceGoals: action.payload,
        }
        case GET_PERFOMANCE_GOALS_SUCCESS:
          return {
              ...state,
              performanceGoals: action.payload,
          }
      case GET_POTENTIAL_LIST_SUCCESS:
        return {
            ...state,
            potentialList: action.payload,
        }
      case SAVE_TECHNICAL_CAPABILITY_SUCCESS:
        return {
            ...state,
            technicalCapability: action.payload,
        }
        case DELETE_TECHNICAL_CAPABILITY_SUCCESS:
          return {
              ...state,
              technicalCapability: action.payload,
          }
      case GET_TECHNICAL_CAPABILITY_SUCCESS:
        return {
            ...state,
            technicalCapability: action.payload,
        }
      case GET_ATTRIBUTE_LIST_SUCCESS:
        return {
            ...state,
            attributes: action.payload,
        }
      case SAVE_BEHAVIOUR_ATTRIBUTES_SUCCESS:
        return {
            ...state,
            behavioural_attributes: action.payload,
        }
      case GET_BEHAVIOUR_ATTRIBUTES_SUCCESS:
        return {
            ...state,
            behavioural_attributes: action.payload,
        }
      case SAVE_PERFORMANCE_LEARNING_PLAN_SUCCESS:
        return {
            ...state,
            performancelearningplan: action.payload,
        }
      case GET_PERFORMANCE_LEARNING_PLAN_SUCCESS:
        return {
            ...state,
            performancelearningplan: action.payload,
        }
     
      case SUBMITDATA_SUCCESS:
        return {
            ...state,
            submitDataStatus: action.payload,
        }
      case GET_REVIEW_APPRAISEE_LIST_SUCCESS:
        return {
            ...state,
            reviewAppraiseeList: action.payload,
        }
      case GET_APPRAISAL_ENABLE_ADMIN_LIST_SUCCESS:
      return {
          ...state,
          appraisalEnableList: action.payload,
      }
      case ENABLE_ALL_APPRAISEE_SUCCESS:
      return {
          ...state,
          appraisalEnableList: action.payload,
      }
      case CHECK_APPRAISAL_ENABLED_STATE_SUCCESS:
      return {
          ...state,
          appraisalEnableStatus: action.payload,
      }
      default:
        return state;
    }
  }
  
  